export enum DiscountType {
    productDiscount = "product-discounts",
    shippingDiscount = "shipping-discounts",
}

export enum DiscountTypeGraphQL {
    UserProductDiscount = "UserProductDiscount",
    UserShippingDiscount = "UserShippingDiscount",
}


// WEBPACK FOOTER //
// ./src/modules/User/types.ts